// removed by extract-text-webpack-plugin
module.exports = {"currentSetting":"Gf26bc9"};